define('../app/fukit/behavior/set.aria.attributes.behavior',['require','exports','module','underscore','marionette'],function(require, exports, module) {
  //prettier-ignore
  var _  = require('underscore'),
      Mn = require('marionette');

  var SetARIAAttributesBehavior = Mn.Behavior.extend({
    defaults: {
      // Pass an object of items where the key is the ARIA attribute suffix and it's paired value is the value to assign.
      //
      // EXAMPLE:
      //
      // ariaItems: {
      //   hidden: true,
      //   role: 'button'
      // }
      // applied to a div would yield <div aria-hidden="true" aria-role="button"></div>.
      // If you pass a value that is a function, the function will be evaluated and the
      // aria value will be set to the result provided it's a string. Functions will be evaluated
      // with the behavior's context of "this".
      ariaItems: {},
    },

    onFirstBeforeRender: function() {
      //prettier-ignore
      var ariaItems = this.getOption('ariaItems'),
          view      = this.view;

      if (this.view && !_.isEmpty(ariaItems)) {
        var ariaAttrs = {};

        // build an object of ARIA attributes to set
        for (var key in ariaItems) {
          //prettier-ignore
          var ariaKey   = 'aria-' + key,
              ariaValue = _.isFunction(ariaItems[key]) ? ariaItems[key].call(this) : ariaItems[key];

          if (typeof ariaValue === 'string') {
            ariaAttrs[ariaKey] = ariaValue;
          }
        }

        view.updateElementAttributes(ariaAttrs);
      }
    },
  });

  module.exports = SetARIAAttributesBehavior;
});

